import { Popover, Transition } from '@headlessui/react';
import { classes } from 'shared';

export function ToolTip({
  title,
  text,
  className,
  color = 'blue',
  pClassName,
  cClassName,
  icon: Icon,
}: {
  title?: string;
  text: string | React.ReactNode;
  className?: string;
  color?: string;
  pClassName?: string;
  cClassName?: string;
  icon?: React.ComponentType<React.ComponentProps<'svg'>>;
}) {
  return (
    <Popover className={classes('relative', cClassName)}>
      <Popover.Button>
        {Icon ? (
          <Icon className={classes(`h-5 w-5 cursor-pointer text-${color}-500`, className)} aria-hidden="true" />
        ) : (
          <span
            className={classes(
              `inline-flex items-center rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-medium bg-${color}-100 text-blue-800 text-${color}-800 cursor-pointer`,
              className,
            )}>
            {title}
          </span>
        )}
      </Popover.Button>

      <Transition
        enter="transition duration-100 ease-out"
        enterFrom="transform scale-95 opacity-0"
        enterTo="transform scale-100 opacity-100"
        leave="transition duration-75 ease-out"
        leaveFrom="transform scale-100 opacity-100"
        leaveTo="transform scale-95 opacity-0">
        <div
          className={classes(
            `absolute z-10 bg-blue-50 bg-${color}-50 my-2 w-64 whitespace-normal rounded-2xl p-2 px-4`,
            pClassName,
          )}>
          <p className="whitespace-normal text-sm font-normal">{text}</p>
        </div>
      </Transition>
    </Popover>
  );
}
